// Re-export FontAwesome SVG Core
// We need the actual implementation for dom.watch() and dom.i2svg() to work
// The bundle size impact is minimal as we only use the core functions
import { library, dom, config } from '@fortawesome/fontawesome-svg-core';

// Configure FontAwesome to automatically replace <i> tags with <svg>
config.autoReplaceSvg = true;
config.autoAddCss = true; // Let FontAwesome add its own CSS for SVG icons

// Export for use in other modules
export { library, dom, config };
